import RytmWebflow from 'rytm-webflow'
import { TimelineMax, TweenMax, Elastic, Expo, Sine, Back, Power1 } from 'gsap'
import { playSound } from './../amzn/sounds'

import WebflowView from './WebflowView'
import { trace } from 'rytm-helpers'

class RepoView extends WebflowView {

  constructor(id) {
    super(id)
  }
  /**
  * animate in (show)
  **/  
  show(container) {
    super.show(container)
    const listBg = [...container.querySelectorAll('.amznobj-repository-bg')]
    listBg.forEach(this.showRepoBg.bind(this))
    this.showTextBlock(container.querySelector('.item-info'))
  }
  /**
  * animate out (hide)
  **/
  hide(container) {
    super.hide(container)
    const listBg = [...container.querySelectorAll('.amznobj-repository-bg')]
    listBg.forEach(this.hideRepoBg.bind(this))
    this.hideTextBlock(container.querySelector('.item-info'))
  }

  
  /**
   * ##########
   * ### OWN ###
   */
  showTextBlock(el) {
    if (!el) {
      return
    }
    playSound("fold_xl")
    const list = [...el.querySelectorAll("p")]
    list.forEach((el, index) => {
      let del = .8 + index * .1;
      del = del > 2 ? 2 : del
      TweenMax.set(el, {opacity: 1})
      TweenMax.from(el, 1, {opacity: 0, delay: del, ease: Power1.easeOut})
    })
  }
  hideTextBlock(el) {
    if (!el) {
      return
    }
    playSound("fold_md")
    const list = [...el.querySelectorAll("p")]
    list.forEach((el, index) => {
      let del = index * .1;
      del = del > 2 ? 2 : del
      TweenMax.to(el, .5, {opacity: 0, delay: del, ease: Power1.easeIn})
    })
    
  }
  /*
  showWord(el, index) {
    const delay = index * .03
    TweenMax.from(el, .65, {y: 50, ease: Expo.easeOut, delay})
  }
  hideWord(el, index) {
    const delay = index * .01
    TweenMax.to(el, .65, {y: -50, ease: Expo.easeOut, delay})
  }
  */

  getRepoBgAnimParams(index) {
    const wW = window.innerWidth
    const wH = window.innerHeight
    let params = { 
      ease: Expo.easeOut 
    }
    switch (index) {
      case 0:
        params.x = wW * .6
        break;
      case 1:
        params.x = - wW * .6
        break;
      default:
        params.y = wH * .3
        break;
    }
    return params
  }
  showRepoBg(el, index) {
    if (!el) {
      return
    }
    let params = this.getRepoBgAnimParams(index, .6)
    // params.onComplete = () => {
    //   playSound("move_xxxs")
    // }
    let del = index * .1 + .6
    del = del > 2 ? 2 : del
    let t1 = new TimelineMax({repeat: 0})
    t1.from(el, .01, {delay: del, onComplete: () => {
      playSound("move_xs")
    }})
    t1.from(el, .6, params)
    // t1.from(el, .7, {scale: .8, ease: Expo.easeOut})
  }
  hideRepoBg(el, index) {
    if (!el) {
      return
    }
    let params = this.getRepoBgAnimParams(index)
    params.ease = Expo.easeIn
    playSound("move_xs")
    let t1 = new TimelineMax({repeat: 0})
    t1.to(el, .3, params)
  }

}

export default RepoView